import { Observable } from 'rxjs';
import { Lightbox } from './lightbox.svc';

/** Handle returned from `Lightbox.openDefault`/`openComponent`, used to interact with that specific invocation. */
export class LightboxRef<T = unknown> {
  readonly closed$: Observable<boolean>;
  readonly dismissed$: Observable<void>;

  constructor(
    private readonly lightboxSvc: Lightbox,
    private readonly getInstance: () => T | null
  ) {
    this.closed$ = this.lightboxSvc.closed$;
    this.dismissed$ = this.lightboxSvc.dismissed$;
  }

  /** The dynamically-loaded component's instance, or `null` when the lightbox is showing default content. */
  get instance(): T | null {
    return this.getInstance();
  }

  close(): void {
    this.lightboxSvc.close();
  }
}
